// Mock data for K&O PHONELAB website

export const companyInfo = {
  name: "PHONELAB 69 VILLEURBANNE",
  tagline: "Votre expert en réparation d'appareils électroniques",
  address: "6 Rue Paul Verlaine, 69100 Villeurbanne",
  phone: "04 26 00 82 10",
  phoneFormatted: "+33426008210", // Format international : enlever le 0, ajouter +33
  phone2: "07 58 25 08 82",
  phone2Formatted: "+33758250882", // Format international : enlever le 0, ajouter +33
  whatsapp: "+33758250882",
  smsLink: "sms:+13509006077&body=Bonjour, je souhaite obtenir un devis pour la réparation de mon appareil. Merci de me contacter.",
  whatsappLink: "https://wa.me/14155238886?text=join%20see-fifty%0A%0ABonjour,%20j'aimerais%20un%20devis%20pour...",
  email: "kophonelab@gmail.com",
  hours: {
    monSat: "9h00 - 19h00",
    allDays: "Lun-Sam: 9h00 - 19h00"
  },
  social: {
    facebook: "https://www.facebook.com/share/1Bju17VNYu/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/kphonelab?igsh=MXJ1N25hY3hxdGx0Ng==",
    tiktok: "https://www.tiktok.com/@phonelab691"
  },
  mapUrl: "https://maps.app.goo.gl/jFQBz3qcJjVscHHq9?g_st=ic",
  googleBusinessUrl: "https://www.google.com/search?gs_ssp=eJzj4tVP1zc0LEguq8wwSTc3YLRSNagwMU8zSTYwSk01TrRMNjE3tzKoSDZMSTMySzIxsEgyNDEwNPLiyc5XKMjIz0tVyElMAgCYuhOS&q=ko+phone+lab"
};

export const stats = {
  experience: "10",
  repairs: "5000+",
  technicians: "2+",
  satisfaction: "100%"
};

export const heroSection = {
  title: "Réparation Smartphone, Tablette & PC à Villeurbanne",
  subtitle: "Meilleur rapport qualité-prix — Garantie jusqu'à 2 ans — Intervention rapide",
  description: "Pièces d'origine en stock immédiat. Diagnostic gratuit. Résultat en 15 minutes sous vos yeux — 10 ans d'expertise à Villeurbanne et Lyon Métropole.",
  cta: "Demander un devis gratuit"
};

export const serviceCategories = [
  {
    id: "portables",
    name: "Portables",
    subtitle: "Iphones, Smartphones",
    icon: "Smartphone",
    image: "https://images.unsplash.com/photo-1603400521630-1598da03180e",
    repairs: [
      {
        name: "Écran cassé",
        description: "Il n'affiche aucune image, le tactile ne répond pas ou présente des traits multicolores."
      },
      {
        name: "Connecteur de charge HS",
        description: "Lorsque vous le connectez au chargeur et que rien ne se passe."
      },
      {
        name: "Le micro ne fonctionne pas",
        description: "Si l'interlocuteur ne vous entend pas."
      },
      {
        name: "Bouton d'Accueil défectueux",
        description: "Bouton Principal dysfonctionnel."
      },
      {
        name: "Haut-parleur défectueux",
        description: "Haut-Parleur dysfonctionnel."
      },
      {
        name: "Caméra avant/arrière HS",
        description: "Si la Caméra ne marche pas, le problème peut venir d'un dysfonctionnement ou d'une déconnexion."
      },
      {
        name: "Bouton de démarrage défectueux",
        description: "Aucune réponse lorsque vous appuyez dessus."
      },
      {
        name: "Batterie qui se décharge rapidement",
        description: "Si celle-ci ne se charge plus ou elle se décharge rapidement."
      }
    ]
  },
  {
    id: "tablettes",
    name: "Tablettes",
    subtitle: "iPad, autres tablettes",
    icon: "Tablet",
    image: "https://images.unsplash.com/photo-1746005718004-1f992c399428",
    repairs: [
      {
        name: "Écran cassé",
        description: "Il n'affiche aucune image, le tactile ne répond pas ou présente des traits multicolores."
      },
      {
        name: "Connecteur de charge cassé",
        description: "Lorsque le téléphone est branché au chargeur sans que celui-ci se charge."
      },
      {
        name: "Le microphone HS",
        description: "Si l'interlocuteur ne vous entend pas lors d'un appel téléphonique."
      },
      {
        name: "Bouton d'accueil HS",
        description: "Lorsque celui-ci ne répond pas."
      },
      {
        name: "Haut-parleur HS",
        description: "Pas de son en HP."
      },
      {
        name: "Caméra avant/arrière HS",
        description: "Si la Caméra ne fonctionne pas, le problème peut venir de la camera elle même ou d'une déconnexion."
      },
      {
        name: "Bouton de démarrage HS",
        description: "Aucune réponse du bouton."
      },
      {
        name: "Batterie HS",
        description: "Si elle ne se charge pas ou se décharge rapidement."
      }
    ]
  },
  {
    id: "ordinateurs",
    name: "Ordinateurs",
    subtitle: "Mac, Bureau, Portable",
    icon: "Laptop",
    image: "https://images.unsplash.com/photo-1746005847013-13291f371f0f",
    repairs: [
      {
        name: "Diagnostic de votre appareil",
        description: "Diagnostic complet de votre ordinateur."
      },
      {
        name: "Écran fissuré",
        description: "Si le verre/LCD est fissuré, présente une image déformée, aucune image ou fonctionne mal."
      },
      {
        name: "Remplacement de la prise d'Alimentation",
        description: "Remplacement de la prise d'Alimentation en cas de panne ou de court circuit."
      },
      {
        name: "Remplacement du Clavier",
        description: "Remplacement du clavier si touches cassées ou en cas de faux contact."
      },
      {
        name: "Service de Nettoyage",
        description: "Nettoyer son pc en cas d'infection par différents virus et optimiser le fonctionnement de l'Appareil."
      },
      {
        name: "Remplacement du Ventilateur",
        description: "Remplacement du ventilateur en cas de dysfonctionnement, court circuit ou surchauffe."
      },
      {
        name: "Remplacement de la Batterie",
        description: "Batterie ne se charge plus ou est épuisée, ça nécessite de la remplacer."
      },
      {
        name: "Installation matérielles & logiciels",
        description: "Installation de matériels et logiciels pour le bon fonctionnement de l'ordinateur ainsi que la configuration des différents logiciels."
      }
    ]
  },
  {
    id: "autres",
    name: "Autres",
    subtitle: "Smart Watch, Console de jeux",
    icon: "Gamepad2",
    image: "https://images.unsplash.com/photo-1768678218064-72683d81bf2b",
    repairs: [
      {
        name: "Remplacement du Port HDMI",
        description: "Remplacement du port HDMI en cas de court-circuit ou de dysfonctionnement."
      },
      {
        name: "Remplacement du Disque Dur",
        description: "Nous pouvons réparer votre disque dur défectueux ou le remplacer en cas de dysfonctionnement."
      },
      {
        name: "Remplacement du Ventilateur",
        description: "Remplacement du ventilateur en cas de dysfonctionnement, court circuit ou surchauffe."
      },
      {
        name: "Alimentation défectueuse",
        description: "Description du défaut du bouton d'alimentation."
      },
      {
        name: "Remplacement du Clavier",
        description: "Remplacement du clavier si touches cassées ou en cas de faux contact."
      },
      {
        name: "Réparation d'Entraînement Optique",
        description: "Réparation d'entraînement Optique."
      },
      {
        name: "Endommagement de l'écran",
        description: "Réparation des dommages écrans."
      },
      {
        name: "Entretien de la Batterie",
        description: "Service d'entretien de la Batterie."
      }
    ]
  }
];

export const processSteps = [
  {
    step: 1,
    title: "Contacter un technicien",
    description: "Détaillez votre problème via le site ou par téléphone. Le technicien sera amplement à votre service."
  },
  {
    step: 2,
    title: "Obtenir son devis",
    description: "Une estimation du prix de la réparation vous sera transmise via le système de messagerie du site ou oralement par le technicien."
  },
  {
    step: 3,
    title: "Déposer l'appareil",
    description: "Vous déposerez votre appareil dans notre boutique où un délai de réparation vous sera donné pour revenir le récupérer."
  }
];

export const advantages = [
  {
    icon: "Shield",
    title: "Garantie d'un an sur TOUTES les réparations",
    description: "Nous soutenons pleinement nos réparations avec une garantie complète d'un an à compter de la date de réparation !"
  },
  {
    icon: "Award",
    title: "Pièces de qualité supérieure",
    description: "Nous n'utilisons que des pièces de qualité supérieure pour réparer vos appareils provenant de fabricants offrant la meilleure qualité disponible sur le marché."
  },
  {
    icon: "Users",
    title: "Plus de 3 000 réparations d'appareils",
    description: "Ayez l'esprit tranquille en sachant que nos techniciens sont entièrement certifiés et ont réparé des milliers d'appareils avant le vôtre !"
  },
  {
    icon: "DollarSign",
    title: "Garantie de prix bas",
    description: "Faire réparer votre appareil ne devrait pas vous ruiner. Notre garantie de prix bas garantit que nous offrons toujours le meilleur prix à nos clients."
  }
];

export const faqs = [
  // ── POSITION ZÉRO — Questions vocales type Siri / Google Assistant ──
  {
    question: "Où réparer mon iPhone à Villeurbanne ?",
    answer: "PHONELAB 69 répare les iPhone à Villeurbanne (6 Rue Paul Verlaine, 69100), accessible en Tram T6 arrêt Gratte-Ciel. Réparation express en 15 minutes, sans rendez-vous, du lundi au samedi."
  },
  {
    question: "Combien coûte la réparation d'un écran iPhone à Villeurbanne ?",
    answer: "Le prix de remplacement d'écran iPhone varie selon le modèle. PHONELAB 69 propose les tarifs les plus compétitifs de Villeurbanne, avec des pièces d'origine garanties 1 an. Diagnostic gratuit pour obtenir votre devis exact en 5 minutes."
  },
  {
    question: "PHONELAB 69 est-il ouvert le samedi ?",
    answer: "Oui, PHONELAB 69 est ouvert le samedi de 10h à 18h à Villeurbanne. Du lundi au vendredi : 9h à 19h. Aucun rendez-vous nécessaire — passez directement en boutique."
  },
  {
    question: "Quelle garantie sur la réparation de mon téléphone ?",
    answer: "PHONELAB 69 garantit toutes ses réparations : 1 an sur les pièces d'origine, 6 mois sur les pièces premium compatibles, 3 mois sur l'entrée de gamme. Les appareils reconditionnés neufs bénéficient d'une garantie 2 ans."
  },
  {
    question: "Combien de temps dure la réparation d'un écran cassé ?",
    answer: "La réparation d'un écran smartphone prend généralement 15 à 30 minutes à PHONELAB 69 à Villeurbanne. Les réparations complexes (carte mère, micro-soudure) peuvent prendre 24 à 48 heures. Diagnostic gratuit et devis immédiat."
  },
  {
    question: "Peut-on réparer un iPhone sans rendez-vous à Villeurbanne ?",
    answer: "Oui, PHONELAB 69 accepte les clients sans rendez-vous du lundi au samedi. Vous pouvez aussi prendre rendez-vous en ligne pour garantir un temps d'attente minimal. La boutique est au 6 Rue Paul Verlaine, Villeurbanne."
  },
  {
    question: "Réparez-vous les Samsung Galaxy à Villeurbanne ?",
    answer: "Oui, PHONELAB 69 répare tous les modèles Samsung Galaxy : écran, batterie, connecteur de charge, caméra, carte mère. Pièces d'origine disponibles en stock à Villeurbanne. Garantie 1 an sur toutes les pièces d'origine."
  },
  {
    question: "Combien coûte le remplacement d'une batterie d'iPhone ?",
    answer: "Le remplacement de batterie iPhone chez PHONELAB 69 à Villeurbanne se fait en 15 minutes avec des pièces certifiées. Le tarif dépend du modèle. Diagnostic de santé batterie gratuit — venez sans rendez-vous."
  },
  {
    question: "PHONELAB 69 répare-t-il les ordinateurs et MacBook ?",
    answer: "Oui, PHONELAB 69 répare les PC portables et MacBook à Villeurbanne : remplacement écran, clavier, batterie, SSD, et micro-soudure carte mère. Diagnostic gratuit sous 24h. Devis fixe avant tout travail."
  },
  {
    question: "Comment aller à PHONELAB 69 en transport en commun ?",
    answer: "PHONELAB 69 est accessible en Tram T6, arrêt Gratte-Ciel à Villeurbanne. Adresse : 6 Rue Paul Verlaine, 69100 Villeurbanne. Également accessible en bus TCL depuis Lyon Part-Dieu et la Guillotière."
  },
  {
    question: "Récupérez-vous les données perdues d'un téléphone cassé ?",
    answer: "Oui, PHONELAB 69 propose la récupération de données sur smartphone cassé, téléphone noyé ou disque dur défaillant à Villeurbanne. Intervention par micro-soudure si nécessaire. Devis gratuit après diagnostic."
  },
  {
    question: "Vendez-vous des téléphones reconditionnés garantis ?",
    answer: "Oui, PHONELAB 69 vend des smartphones reconditionnés et neufs avec une garantie 2 ans à Villeurbanne. iPhone, Samsung, Xiaomi disponibles en stock. Rapport qualité-prix imbattable avec suivi SAV local."
  },
  {
    question: "Réparez-vous les tablettes iPad et Samsung à Villeurbanne ?",
    answer: "Oui, PHONELAB 69 répare tous les modèles d'iPad Apple et tablettes Samsung à Villeurbanne : remplacement d'écran, batterie, connecteur, caméra. Pièces disponibles en stock, garantie 1 an sur les pièces d'origine."
  },
  {
    question: "Proposez-vous un devis gratuit avant réparation ?",
    answer: "Oui, le diagnostic et le devis sont 100% gratuits et sans engagement chez PHONELAB 69 à Villeurbanne. Vous connaissez le prix exact avant que la réparation commence. Aucune mauvaise surprise."
  },
  {
    question: "Quel est le meilleur réparateur de téléphone près de Lyon ?",
    answer: "PHONELAB 69 à Villeurbanne (69100) est l'expert réparation smartphone de la métropole lyonnaise, avec 10 ans d'expérience, une note de 4.8/5, des prix compétitifs et une garantie jusqu'à 2 ans. Accessible depuis Lyon, Bron, Vaulx-en-Velin et Caluire."
  }
];

export const testimonials = [
  {
    name: "de Villoutreys Anne",
    rating: 5,
    text: "Prise en charge rapide, accueil et service agréable, prix correct, merci !! Je recommande :)",
    date: "Il y a 1 mois"
  },
  {
    name: "Othman Malouane",
    rating: 5,
    text: "Service très professionnelle, hyper sympa et efficace. Avec un très très bon rapport qualité prix.",
    date: "Il y a 1 mois"
  },
  {
    name: "Pierre Bertoni",
    rating: 5,
    text: "Très professionnels. Ils sont très transparents sur ce qu'ils font. Vitre de smartphone remplacées en quelques minutes pour un prix très attractif",
    date: "Il y a 1 mois"
  },
  {
    name: "ali silem",
    rating: 5,
    text: "Très professionnel prix abordable et très correct. À recommander!",
    date: "Il y a 1 mois"
  },
  {
    name: "Miss",
    rating: 5,
    text: "Accueil chaleureux, service rapide et efficace, rapport qualité prix rien à dire! Je recommande!!",
    date: "Il y a 2 mois"
  },
  {
    name: "yossef kahn",
    rating: 5,
    text: "excellent!!! service rapide efficace et agreable!! je recommande fortement",
    date: "Il y a 2 mois"
  },
  {
    name: "Jean PUGNET",
    rating: 5,
    text: "Merci et félicitations au technicien très compétent et très patient. Magasin à recommander.",
    date: "Il y a 2 mois"
  },
  {
    name: "Maxime Chiono",
    rating: 5,
    text: "Petit problème de charge résolu très rapidement ! Merci!",
    date: "Il y a 1 mois"
  }
];

export const deviceBrands = {
  smartphones: ["Apple", "Samsung", "Huawei", "Xiaomi", "OnePlus", "Google", "Sony"],
  tablets: ["Apple", "Samsung", "Lenovo", "Huawei", "Microsoft"],
  computers: ["Apple", "Asus", "Lenovo", "HP", "Dell", "Toshiba", "Acer"]
};
